module.exports = __webpack_public_path__ + "static/rhuigi-2468b5b2bc2748baacf85924994e6017.jpg";